import React, { useState } from "react";
import logo from "../../images/managekaro logo.png";
import resetLogo from "../../images/resetlogo.png";
import { Link } from "react-router-dom";
import {
  Button,
  Stack,
  TextField,
  Typography,
  Container,
  Box,
  useMediaQuery,
  Grid,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import UserRepository from "../../Repository/UserRepository";
import { toast } from "react-toastify";
import ClipLoader from "react-spinners/ClipLoader";

const schema = yup
  .object()
  .shape({
    password: yup
      .string()
      .required("Password is Required")
      .min(8, "Password is too short"),
    passwordVerification: yup
      .string()
      .required("Required")
      .oneOf([yup.ref("password"), null], "Passwords Not Matching"),
  })
  .required();

function UpdatePassword(props) {
  const [state, setState] = useState({
    loading: false,
    reset: false,
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onTouched",
  });

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("md"));

  const verify = async (data) => {
    setState((prev) => ({ ...prev, loading: true }));

    await UserRepository.usersModel({
      request: {
        method: "updatePassword",
        data: {
          _id: props.match.params.id,
          password: data.password,
          reset_password_token: props.match.params.code,
        },
      },
    });
    setState((prev) => ({ ...prev, loading: false, reset: true }));
    toast.configure();
    toast.success("Password reset successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
  };

  return (
    <Grid container>
      <Grid align="center" item lg={6} md={6} sm={12}>
        <Container>
          <Stack
            direction="column"
            spacing={3}
            justifyContent="center"
            alignItems="center"
            width="80%"
            sx={{ marginBottom: "20px" }}
          >
            <img className="logoiconlg" src={logo} alt="logo" />
            <Typography variant="h5" sx={{ color: "#4EAF51" }}>
              The Best Solution For All Your Inventory Needs
            </Typography>
            <Typography variant="h5" sx={{ color: "#757575" }}>
              Please Enter Your New Password Below
            </Typography>
          </Stack>

          {!state.reset && (
            <Stack
              direction="column"
              spacing={2}
              justifyContent="center"
              alignItems="center"
              width="60%"
              sx={{ margin: "0 auto" }}
            >
              <TextField
                autoFocus
                label="New Password"
                type="text"
                name="password"
                variant="outlined"
                fullWidth
                {...register("password")}
              />
              <Typography sx={{ color: "red" }}>
                {errors.password?.message}
              </Typography>
              <TextField
                variant="outlined"
                label="Confirm Password"
                name="passwordVerification"
                type="text"
                fullWidth
                {...register("passwordVerification")}
              />
              <Typography sx={{ color: "red" }}>
                {errors.passwordVerification?.message}
              </Typography>
              <ClipLoader size={50} color={"#4DAF51"} loading={state.loading} />
              {!state.loading && (
                <Button
                  variant="contained"
                  onClick={handleSubmit(verify)}
                  sx={{ background: "#4EAF51", color: "white" }}
                >
                  Submit
                </Button>
              )}
            </Stack>
          )}

          {state.reset && (
            <Stack
              direction="column"
              spacing={3}
              justifyContent="center"
              alignItems="center"
              sx={{ margin: "0 auto" }}
            >
              <Typography variant="h4">
                Your password has been reset!
              </Typography>
              <Link to="/inventory/login">
                <Button
                  variant="contained"
                  sx={{ background: "#4EAF51", color: "white" }}
                >
                  Log In
                </Button>
              </Link>
            </Stack>
          )}
        </Container>
      </Grid>
      {!matches && (
        <Grid item lg={6} md={6} sm={12}>
          <Box className="center inventorylogo">
            <img id="reset-main" src={resetLogo} alt="logo" />
          </Box>
        </Grid>
      )}
    </Grid>
  );
}

export default UpdatePassword;
